import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import { useTransactionChart } from './useTransactionChart'
import { TransactionChartResponse } from '../../../../../app/services/transactionService/transactionChart'
import { Skeleton } from '@/view/components/ui/skeleton'
import { useProductsCatalog } from '@/app/hooks/useProductsCatalog'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
)

interface TransactionsChartProps {
  data: TransactionChartResponse | undefined
  isLoading: boolean
  metric?: 'total' | 'count'
}

export function TransactionsChart({
  data,
  isLoading,
  metric,
}: TransactionsChartProps) {
  const { getProductLabel, getProductColor } = useProductsCatalog()
  const { data: graphData, options } = useTransactionChart(
    data,
    metric,
    getProductLabel,
    getProductColor,
  )

  return (
    <div className="max-w-full overflow-auto">
      <div className="mt-2 flex flex-row-reverse gap-2"></div>
      <div>
        {isLoading ? (
          <Skeleton className="m-5 h-[280px]" />
        ) : (
          <Line
            style={{ height: '280px' }}
            options={options}
            data={graphData}
          />
        )}
      </div>
    </div>
  )
}
